import React, { useEffect, useRef } from "react";
import gsap from "gsap";

const StepModal = props => {

    const riferimento = useRef()
    const lang = document.documentElement.lang === "it"

    useEffect(() =>{
        let mm = gsap.matchMedia();
        mm.add("(max-width: 992px)", () => {
            props.isModalOpen ? riferimento.current.scrollIntoView({ behavior: 'smooth', block: "start"}) : document.body.scrollIntoView({block: "start", inline: "nearest"})
        })
    },[props.isModalOpen])

    return(
        <div className={`full-height info-details info d-none bg-color`}>
            <div className="container-fluid full-height">
                <div className="row full-height d-flex align-items-center">
                    <div className="col-md-10 mx-auto mt-lg-4 text-center text-lg-start">
                        <p ref={riferimento} className="text-color p-big mb-4 text-start">
                            <b>{lang ? "Calendario" : "Calendar"} {props.calendar}</b><br/>
                            <b className="tit">{props.titolo}</b><br/>
                            by <b>{props.author}</b>
                        </p>
                        <img alt="reference" className="img-fluid mb-3 pb-3  text-start" src={props.photo}/>
                        <p className="text-white mb-5 text-start">{lang ? props.description.it : props.description.en}</p>
                        <button onClick={props.nextStep} className="btn btn-outline-dark btn-lg btn-lavazza">{lang ? "PROSSIMO EASTER EGG ":"NEXT EASTER EGG "}
                            <svg xmlns="http://www.w3.org/2000/svg" width="4" height="8" viewBox="0 0 4 8">
                              <path id="Poligono_2" data-name="Poligono 2" d="M4,0,8,4H0Z" transform="translate(4) rotate(90)" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StepModal